import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiGetListingPriorityCsvParams,
  BackendErrorEntity,
  GetMostRelevantSaleResponseDto,
  SetListingPriorityCsvBodyDto,
  SetListingPriorityCsvResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetMostRelevantSaleByVin = (
    vin: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      vin = unref(vin);
      
      return fetchApiInstance<GetMostRelevantSaleResponseDto>(
      {url: `/sales/by-vin/${vin}/most-relevant`, method: 'GET'
    },
      options);
    }
  

export const getApiGetMostRelevantSaleByVinQueryKey = (vin: MaybeRef<string | undefined | null>,) => {
    return ['sales','by-vin',vin,'most-relevant'] as const;
    }

    
export const getApiGetMostRelevantSaleByVinQueryOptions = <TData = Awaited<ReturnType<typeof apiGetMostRelevantSaleByVin>>, TError = ErrorType<BackendErrorEntity>>(vin: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetMostRelevantSaleByVin>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetMostRelevantSaleByVinQueryKey(vin);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetMostRelevantSaleByVin>>> = () => apiGetMostRelevantSaleByVin(vin, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(vin))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetMostRelevantSaleByVin>>, TError, TData> 
}

export type ApiGetMostRelevantSaleByVinQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetMostRelevantSaleByVin>>>
export type ApiGetMostRelevantSaleByVinQueryError = ErrorType<BackendErrorEntity>



export function useApiGetMostRelevantSaleByVin<TData = Awaited<ReturnType<typeof apiGetMostRelevantSaleByVin>>, TError = ErrorType<BackendErrorEntity>>(
 vin: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetMostRelevantSaleByVin>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetMostRelevantSaleByVinQueryOptions(vin,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiGetMostRelevantSaleByVehicleCode = (
    vehicleCode: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      vehicleCode = unref(vehicleCode);
      
      return fetchApiInstance<GetMostRelevantSaleResponseDto>(
      {url: `/sales/by-vehicle-code/${vehicleCode}/most-relevant`, method: 'GET'
    },
      options);
    }
  

export const getApiGetMostRelevantSaleByVehicleCodeQueryKey = (vehicleCode: MaybeRef<string | undefined | null>,) => {
    return ['sales','by-vehicle-code',vehicleCode,'most-relevant'] as const;
    }

    
export const getApiGetMostRelevantSaleByVehicleCodeQueryOptions = <TData = Awaited<ReturnType<typeof apiGetMostRelevantSaleByVehicleCode>>, TError = ErrorType<BackendErrorEntity>>(vehicleCode: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetMostRelevantSaleByVehicleCode>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetMostRelevantSaleByVehicleCodeQueryKey(vehicleCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetMostRelevantSaleByVehicleCode>>> = () => apiGetMostRelevantSaleByVehicleCode(vehicleCode, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(vehicleCode))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetMostRelevantSaleByVehicleCode>>, TError, TData> 
}

export type ApiGetMostRelevantSaleByVehicleCodeQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetMostRelevantSaleByVehicleCode>>>
export type ApiGetMostRelevantSaleByVehicleCodeQueryError = ErrorType<BackendErrorEntity>



export function useApiGetMostRelevantSaleByVehicleCode<TData = Awaited<ReturnType<typeof apiGetMostRelevantSaleByVehicleCode>>, TError = ErrorType<BackendErrorEntity>>(
 vehicleCode: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetMostRelevantSaleByVehicleCode>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetMostRelevantSaleByVehicleCodeQueryOptions(vehicleCode,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiGetListingPriorityCsv = (
    params: MaybeRef<ApiGetListingPriorityCsvParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<string>(
      {url: `/sales/listing-priority-csv`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetListingPriorityCsvQueryKey = (params: MaybeRef<ApiGetListingPriorityCsvParams>,) => {
    return ['sales','listing-priority-csv', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetListingPriorityCsvQueryOptions = <TData = Awaited<ReturnType<typeof apiGetListingPriorityCsv>>, TError = ErrorType<BackendErrorEntity>>(params: MaybeRef<ApiGetListingPriorityCsvParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetListingPriorityCsv>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetListingPriorityCsvQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetListingPriorityCsv>>> = () => apiGetListingPriorityCsv(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetListingPriorityCsv>>, TError, TData> 
}

export type ApiGetListingPriorityCsvQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetListingPriorityCsv>>>
export type ApiGetListingPriorityCsvQueryError = ErrorType<BackendErrorEntity>



export function useApiGetListingPriorityCsv<TData = Awaited<ReturnType<typeof apiGetListingPriorityCsv>>, TError = ErrorType<BackendErrorEntity>>(
 params: MaybeRef<ApiGetListingPriorityCsvParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetListingPriorityCsv>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetListingPriorityCsvQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiSetListingPriorityCsv = (
    setListingPriorityCsvBodyDto: MaybeRef<SetListingPriorityCsvBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      setListingPriorityCsvBodyDto = unref(setListingPriorityCsvBodyDto);
      const formData = new FormData();
formData.append('sellingMethod', setListingPriorityCsvBodyDto.sellingMethod)
formData.append('file', setListingPriorityCsvBodyDto.file)

      return fetchApiInstance<SetListingPriorityCsvResponseDto>(
      {url: `/sales/listing-priority-csv`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiSetListingPriorityCsvMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSetListingPriorityCsv>>, TError,{data: BodyType<SetListingPriorityCsvBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiSetListingPriorityCsv>>, TError,{data: BodyType<SetListingPriorityCsvBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiSetListingPriorityCsv>>, {data: BodyType<SetListingPriorityCsvBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiSetListingPriorityCsv(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiSetListingPriorityCsvMutationResult = NonNullable<Awaited<ReturnType<typeof apiSetListingPriorityCsv>>>
    export type ApiSetListingPriorityCsvMutationBody = BodyType<SetListingPriorityCsvBodyDto>
    export type ApiSetListingPriorityCsvMutationError = ErrorType<BackendErrorEntity>

    export const useApiSetListingPriorityCsv = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSetListingPriorityCsv>>, TError,{data: BodyType<SetListingPriorityCsvBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiSetListingPriorityCsv>>,
        TError,
        {data: BodyType<SetListingPriorityCsvBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiSetListingPriorityCsvMutationOptions(options);

      return useMutation(mutationOptions);
    }
    